import { useCallback, useRef, useState } from "react";
import { PERIOD } from "common/utils/consts";
import { getPeriodRange } from "common/utils/helpers";

export interface IReportRange {
  dateFrom?: string;
  dateTo?: string;
}

// Локальные фильтры отчёта: вкладка периода, произвольный диапазон дат и поиск.
// Выбор дат в пикере снимает вкладку; DatePicker при монтировании и очистке
// присылает null — при активной вкладке такие вызовы игнорируются
export function useReportFilters(initialPeriod: number = PERIOD.MONTH) {
  const [period, setPeriod] = useState<Undefinable<number>>(initialPeriod);
  const [range, setRange] = useState<IReportRange>(() =>
    getPeriodRange(initialPeriod)
  );
  const [search, setSearch] = useState<string>("");
  const periodRef = useRef<Undefinable<number>>(initialPeriod);

  const selectPeriod = useCallback((value: number) => {
    periodRef.current = value;
    setPeriod(value);
    setRange(getPeriodRange(value));
  }, []);

  const handleDateFromChange = useCallback((date: Nullable<Date>) => {
    if (!date && periodRef.current !== undefined) return;
    periodRef.current = undefined;
    setPeriod(undefined);
    setRange((prev) => ({ ...prev, dateFrom: date?.toISOString() }));
  }, []);

  const handleDateToChange = useCallback((date: Nullable<Date>) => {
    if (!date && periodRef.current !== undefined) return;
    periodRef.current = undefined;
    setPeriod(undefined);
    setRange((prev) => ({ ...prev, dateTo: date?.toISOString() }));
  }, []);

  return {
    period,
    dateFrom: range.dateFrom,
    dateTo: range.dateTo,
    search,
    setSearch,
    selectPeriod,
    handleDateFromChange,
    handleDateToChange,
  };
}
